import type { ComponentProps } from "react";

export const InfoIcon = ({
  color = "#F8F9FA",
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="9" stroke={color} stroke-width="1.5" />
      <path
        d="M12 9V9.001"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="12"
        y1="12"
        x2="12"
        y2="16"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
